import { apiGet, apiPatch } from './client';
import type {
  NonTradingDay4Fund,
  NonTradingDay4FundBatchRequest,
} from '../types/NonTradingDay4Fund';

// Tenant-scoped (X-Tenant-Id applied automatically by the client).

export function getNonTradingDays4Fund(): Promise<NonTradingDay4Fund[]> {
  return apiGet<NonTradingDay4Fund[]>('/api/non-trading-days-4-fund');
}

export function saveNonTradingDays4FundBatch(
  added: NonTradingDay4Fund[],
  modified: NonTradingDay4Fund[],
  deletedIds: number[],
): Promise<NonTradingDay4Fund[]> {
  return apiPatch<NonTradingDay4FundBatchRequest, NonTradingDay4Fund[]>(
    '/api/non-trading-days-4-fund/batch',
    {
      added,
      modified,
      deleted: deletedIds,
    },
  );
}
